import * as z from "zod";
import { HsCodeItemSchema } from "./get-hs-codes";

export const searchHsCodes = {
  name: "searchHsCodes" as const,
  input: z.object({ query: z.string() }),
  output: z.object({ results: z.array(HsCodeItemSchema) }),
};
